import Skills from '../c_Skills';

// class name
// import cx from 'classnames';

export default class SkillSection extends Skills {
  constructor(props, context) {
    super(props, context);
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Skills/c_SkillSection/index.js